import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card card-flush h-md-100" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body pt-1" }
const _hoisted_5 = { class: "fw-bolder text-gray-600 mb-5" }
const _hoisted_6 = { class: "d-flex flex-column text-gray-600" }
const _hoisted_7 = {
  key: 0,
  class: "py-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-primary me-3" }, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "d-flex align-items-center py-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-primary me-3" }, null, -1)
const _hoisted_12 = { class: "card-footer flex-wrap pt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-2 position-relative top-1" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-2 position-relative top-1" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-2 position-relative top-1" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.nom), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, "Nombre total de permission ayant ce rôle: " + _toDisplayString(_ctx.privileges?.length), 1),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.privileges, (pri, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex align-items-center",
            key: index
          }, [
            (index < 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  (pri.permission )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(pri.permission.description), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        (_ctx.number > 5)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("em", null, "et " + _toDisplayString(_ctx.number - 5) + " de plus...", 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_link, {
        to: { name: 'ViewRolePage', params: { id: _ctx.id } },
        class: "default-btn me-2 text-white btn bg-success btn-sm"
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: { name: 'EditRolePage', params: { id: _ctx.id } },
        class: "btn btn-sm btn-primary my-1 me-2"
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete'))),
        class: "btn btn-sm btn-danger btn-active-danger my-1"
      }, _hoisted_16)
    ])
  ]))
}